import { createActionGroup, emptyProps } from '@ngrx/store';
import { props } from '@ngrx/store';
import { ContentType } from '@core/models/content-type.models';
import { Folder, FolderQueryParams } from '@core/models/folder.model';
import { VideoData, VideoQueryParams } from '@core/models/entities/video.models';
import { WlcmPaginatedData } from '@wlcm/common';
import { PaginatedData } from '@core/models/pagination.models';

const PREFIX = '[ON-DEMAND]';
export const OnDemandActions = createActionGroup({
  source: `${PREFIX} Root`,
  events: {
    getContentTypes: props<FolderQueryParams>(),
    getContentTypesSuccess: props<WlcmPaginatedData<ContentType>>(),
    initCollections: props<FolderQueryParams>(),
    initCollectionsSuccess: props<PaginatedData<Folder>>(),
    getCollections: props<FolderQueryParams>(),
    getCollectionsSuccess: props<PaginatedData<Folder>>(),
    clearCollections: emptyProps(),
    getVideos: props<VideoQueryParams>(),
    getVideosSuccess: props<WlcmPaginatedData<VideoData>>(),
    loadingVideos: props<{ isLoading: boolean }>(),
    clearVideos: emptyProps(),
    updateSliderStatus: emptyProps(),
    updateSliderRange: props<{ range: number }>(),
    error: props<{ error: string }>(),
  },
});
